import { useTranslation } from 'react-i18next'

import type { AuditModel } from '@cdab/scania/qpr/offline/models'
import { capitalizeFirstLetter } from '@cdab/utils'
import { TdsButton } from '@scania/tegel-react'
import styled from 'styled-components'

const StyledTdsButton = styled(TdsButton)`
  &&& {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    button {
      display: block;
    }
  }
`

export function PrintAuditNotesButton(props: { audit: AuditModel }) {
  const { t } = useTranslation('audit')

  const hasNotes = props.audit.auditPoints.some(
    p => p.note && p.note.trim() !== ''
  )

  if (!hasNotes) return null

  return (
    <a
      className='tds-u-flex-dir-col tds-u-w100'
      href={`/audit/${props.audit.id}/notes-print`}
      target='_blank'
      rel='noreferrer'
    >
      <StyledTdsButton text={capitalizeFirstLetter(t('audit-notes'))} />
    </a>
  )
}
